import { type ComponentRoute } from './types';

const allPages: ComponentRoute[] = [
  {
    path: 'terms-of-use',
    name: 'TermsOfUse',
    component: () => {
      const locale = localStorage.getItem('language') || 'uk';
      if (locale === 'en') {
        return import('@/views/public/TermsOfUseEn.vue');
      } else {
        return import('@/views/public/TermsOfUseUk.vue');
      }
    },
  },
  {
    path: 'privacy-policy',
    name: 'PrivacyPolicy',
    component: () => {
      const locale = localStorage.getItem('language') || 'uk';
      if (locale === 'en') {
        return import('@/views/public/PrivacyPolicyEn.vue');
      } else {
        return import('@/views/public/PrivacyPolicyUk.vue');
      }
    },
  },
];

const PublicRoutes = {
  path: '/public',
  component: () => import('@/layouts/blank/BlankLayout.vue'),
  meta: {
    requiresAuth: false,
  },
  children: allPages,
};

export default PublicRoutes;
